/**
 * <cart-discount> — applies a discount code from the cart page.
 *
 * Uses Shopify's /discount/{CODE} endpoint, which validates the code, stores
 * it on the cart, and redirects back to the cart where it shows in the totals
 * (and carries through to checkout). Honest: invalid codes simply don't apply.
 */
if (!customElements.get('cart-discount')) {
  customElements.define(
    'cart-discount',
    class CartDiscount extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('input');
        this.button = this.querySelector('[data-cart-discount-apply]');
        if (this.button) this.button.addEventListener('click', () => this.apply());
        if (this.input) {
          this.input.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              this.apply();
            }
          });
        }
      }

      apply() {
        const code = (this.input.value || '').trim();
        if (!code) return;
        const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
        window.location.href =
          '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(cartUrl);
      }
    }
  );
}
